export const portPOIQueryKeys = {
  all: ['cruise-port-pois'] as const,
  details: () => [...portPOIQueryKeys.all, 'detail'] as const,
  detail: (portId: string) => [...portPOIQueryKeys.details(), portId] as const,
};
